import Categories from './Categories';
import Modal from '../UI/Modal/Modal';

// import CategoryModalClasses from './CategoryModal.module.css';

const CategoryModal = (props) => {
    return(
        <Modal onClose={props.onClose}><Categories idPrefix='modal'/></Modal>
    );
};

export default CategoryModal;